import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StripeService } from '../_servizi/stripe.service';
import { MessageServiceService } from '../_servizi/message-service.service';
import { StepService } from '../_servizi/step.service';
import { TranslateService } from '@ngx-translate/core';
import { ClientiService } from '../_servizi/clienti.service';
import { CarrelloViniService } from '../_servizi/carrelloVini.service';

@Component({
  selector: 'app-step3',
  templateUrl: './step3.component.html',
  styleUrls: ['./step3.component.css']
})
export class Step3Component implements OnInit {

  errore: string;
  successo: any = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageServiceService,
    private stripeService: StripeService,
    private translate: TranslateService,
    private carrelloService: CarrelloViniService
  ) {
    this.route.paramMap.subscribe((params) => {
      this.successo = params.get('risultato') === 'ok' ? true : false;
      if (!this.successo) {
        this.removeIdCliente();
      }
    });

  }

  ngOnInit(): void {
  }

  removeIdCliente() {
    this.carrelloService.removeIdCliente().subscribe(response => {
      console.log("cookie ripristinati e id utente rimosso")
    });
  }

  backToSetp2() {
    this.stripeService.loading = false;
    const idCookie = this.messageService.getIdCookie();
    this.router.navigateByUrl('step2/' + idCookie + '/' + this.translate.currentLang);
  }

}
